import { useSyncExternalStore } from 'react';

/**
 * True where there is a pointer that can hover.
 *
 * The JS mirror of `@media (hover: none)` in ChannelPreview.module.css, and it
 * has to stay the same question: that block is what holds the row checkboxes
 * out on touch, and anything offering to put them away has to know whether the
 * offer means anything.
 *
 * Hover capability, not viewport width: a laptop dragged narrow still has a
 * pointer. Subscribed rather than read once, unlike the keyboard in `device.ts`:
 * a 2-in-1 folding into tablet mode flips this under a running tab, the CSS
 * follows it at once, and a stale answer here is a switch still on offer over
 * rows it can no longer move.
 */
// One MediaQueryList for the app, not one per render: the query is constant and
// the MQL is a stable browser object. Null only outside a browser (e.g. a test
// env without matchMedia), where the answer is that it hovers — the desktop
// reading, as `useIsMobile` also falls to desktop.
const mql =
  typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(hover: none)') : null;

function subscribe(onChange: () => void): () => void {
  mql?.addEventListener('change', onChange);
  return () => mql?.removeEventListener('change', onChange);
}

export function useCanHover(): boolean {
  return useSyncExternalStore(subscribe, () => !mql?.matches);
}
